import type { FC } from 'react';
import React from 'react';
import type { MatchStatusProps } from './MatchStatus.types';
import styles from './MatchStatus.module.scss';
export const MatchStatus: FC<MatchStatusProps> = ({
  status,
  className
}) => {
  const [statusDate, statusTime] = status.split(' ');
  return <>
      {status && <div className={cn(styles.root, className)}>
          <p>{statusDate}</p>
          <p className={styles.statusTime}>{statusTime}</p>
        </div>}
    </>;
};